import React from "react";

const EmptyFooter = () => {
  return <div />;
};

export default EmptyFooter;
